import { render, staticRenderFns } from "./VideoReviewsTab.vue?vue&type=template&id=bce6920a&scoped=true"
import script from "./VideoReviewsTab.vue?vue&type=script&lang=js"
export * from "./VideoReviewsTab.vue?vue&type=script&lang=js"
import style0 from "./asset-split.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VideoReviewsTab.vue?vue&type=style&index=1&id=bce6920a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce6920a",
  null
  
)

export default component.exports